import { Chart, registerables, ChartType } from "chart.js";

Chart.register(...registerables);

interface CanvasData {
    name: string;
    value: number;
}

const colours = {
    completed: "rgb(0, 192, 109)",
    inProgress: "rgb(67, 103, 251)",
    notStarted: "rgb(223, 229, 240)",
};

function CreateProgressChart(CanvasId: string) {
    const canvas = document.getElementById(CanvasId) as HTMLCanvasElement;
    if (!canvas) return;
    const canvasData = canvas.getAttribute(`data-${CanvasId}`);
    const data = canvasData !== null ? (JSON.parse(canvasData) as CanvasData[]) : [];

    const labels: string[] = data.map(({ name }) => name);
    const values: number[] = data.map(({ value }) => value);

    const chartData = {
        labels: labels,

        datasets: [
            {
                label: "My First Dataset",
                data: values,
                backgroundColor: [colours.completed, colours.inProgress, colours.notStarted],
            },
        ],
    };

    const config = {
        type: "doughnut" as ChartType,
        data: chartData,
        options: {
            plugins: {
                legend: {
                    display: false,
                },
            },
            elements: {
                arc: {
                    borderWidth: 0
                }
            }
        },
    };

    const myChart = new Chart(canvas, config);
}

CreateProgressChart("donut-chart");
export default undefined;
